export default __webpack_public_path__ + "static/media/author-5.93217714.png";